// Coins / diamonds / money keep up to 4–6 decimals in the database (never
// rounded there). On screen: at most 2 decimals, trailing zeros dropped —
// 7, 0.7, 7.77 (never 7.7777, never 7.00).
export const num = (v, max = 2) => {
  const n = Number(v);
  if (v === null || v === undefined || v === "" || Number.isNaN(n)) return "0";
  return n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: max });
};
